"use strict";
(function() {
    function showError(msg) {
        window.alert(msg);
    }
    try {
        new CSSStyleSheet();
    } catch  {
        showError(`\u{60A8}\u{7684}\u{6D4F}\u{89C8}\u{5668}\u{4E0D}\u{652F}\u{6301}\u{521B}\u{5EFA}CSSStyleSheet\u{3002}\
\u{5982}\u{679C}\u{60A8}\u{662F}iOS\u{7528}\u{6237}\u{FF0C}\u{60A8}\u{9700}\u{8981}\u{5C06}\u{7CFB}\u{7EDF}\u{5347}\u{7EA7}\u{5230}\u{7248}\u{672C}16.4\u{4EE5}\u{4E0A}\u{FF0C}\
\u{5E76}\u{4E14}\u{5728}Safari\u{7684}\u{9AD8}\u{7EA7}\u{8BBE}\u{7F6E}\u{4E2D}\u{5C06}"Experimental Features"\u{4E2D}\u{7684}\
"Constructable Stylesheets"\u{9009}\u{9879}\u{5F00}\u{542F}\u{624D}\u{80FD}\u{6B63}\u{5E38}\u{4F7F}\u{7528}\u{6B64}\u{7F51}\u{7AD9}\u{3002}`);
    }
})();

//# sourceMappingURL=arcaea-toolbelt.313db941.js.map
